<template>
  <div>
    <!-- <el-button @click="testLogConcurrency">测试按钮</el-button> -->
  </div>
</template>

<script>
import { uploadLiveLog, forceFlushLogs } from "@saas/components/src/utils/log";

export default {
  data() {
    return {
      videoUrl:
        "https://saas-api-1324980469.cos.ap-beijing.myqcloud.com/Test/upload/video/20250313/FbqUoQ9S0S.mp4?q-sign-algorithm=sha1&q-ak=AKID3yiJhqsjSmxvrfQ9nFaqxyyCb9f7fPOK&q-sign-time=1758888266;1758931466&q-key-time=1758888266;1758931466&q-header-list=host&q-url-param-list=&q-signature=dcfbcf28335a4a70e1a1eb7e06f6be181cf101e4",
      time: 5,
    };
  },
  async mounted() {
    [1, 45, 67, 89, 234].forEach((item) => {
      this.time = item;
      this.getVideoFrame();
    });
  },
  methods: {
    /**
     * 测试日志并发上传是否会丢数据
     */
    async testLogConcurrency() {
      console.log("=== 开始日志并发测试 ===");
      // console.log("测试前队列状态:", this.getLogQueueInfo());

      // 测试1: 并发上传冲突
      console.log("\n📌 测试1: 并发上传冲突");
      console.log("添加50条日志，触发阈值上传...");

      // 快速添加 50 条日志
      for (let i = 1; i <= 50; i++) {
        uploadLiveLog({
          message: `并发测试-日志${i}`,
          level: "info",
          tag: "test",
        });
      }

      // 立即再次触发上传（模拟并发）
      setTimeout(() => {
        console.log("🔥 模拟并发：手动触发第二次上传");

        forceFlushLogs();
      }, 100);

      // 在并发期间继续添加日志
      setTimeout(() => {
        console.log("📝 并发期间添加新日志...");
        for (let i = 51; i <= 55; i++) {
          uploadLiveLog({
            message: `并发期间-日志${i}`,
            level: "info",
            tag: "test",
          });
        }
      }, 200);

      // 测试2: 定时器+阈值同时触发
      setTimeout(() => {
        console.log("\n📌 测试2: 定时器+阈值同时触发");
        console.log("添加49条日志...");

        // 添加 49 条
        for (let i = 1; i <= 49; i++) {
          uploadLiveLog({
            message: `定时器测试-日志${i}`,
            level: "info",
            tag: "test",
          });
        }

        // 100ms 后添加第 50 条（触发阈值）
        setTimeout(() => {
          console.log("📊 添加第50条，触发阈值上传");
          uploadLiveLog({
            message: "定时器测试-第50条",
            level: "info",
            tag: "test",
          });
        }, 100);

        // 同时手动触发（模拟定时器到了）
        setTimeout(() => {
          console.log("⏰ 模拟定时器同时触发");

          forceFlushLogs();
        }, 120);

        // 继续添加
        setTimeout(() => {
          console.log("📝 冲突后继续添加日志");
          uploadLiveLog({
            message: "定时器测试-冲突后的新日志",
            level: "info",
            tag: "test",
          });
        }, 300);
      }, 3000);

      // 测试3: 快速连续调用
      setTimeout(() => {
        console.log("\n📌 测试3: 快速连续调用100次");

        for (let i = 1; i <= 100; i++) {
          uploadLiveLog({
            message: `快速调用-日志${i}`,
            level: "info",
            tag: "test",
          });
        }

        console.log("✅ 已快速添加100条日志");
      }, 6000);

      // 最终验证
      setTimeout(() => {
        console.log("\n=== 测试完成，验证结果 ===");
        console.log("预期总日志数: 50 + 5 + 49 + 1 + 1 + 100 = 206 条");
        console.log("实际情况请查看网络请求和控制台");
        console.log("如果没有丢失，应该能看到所有日志都上传了");
        this.$darkMessage.success("测试完成，请查看控制台和网络请求");
      }, 10000);
    },
    async getVideoFrame() {
      const canvas = await this.getVideoFrameAtSecond(this.videoUrl, this.time);
      // 可以将canvas转换为图片显示在页面上
      const frameImage = document.createElement("img");
      frameImage.src = canvas.toDataURL("image/png"); // 转换为base64图片

      this.$refs.previewMain.appendChild(frameImage);
    },
    /**
     * 获取视频指定时间点的帧画面
     * @param {string} videoUrl - 视频地址
     * @param {number} seconds - 需要捕获的时间点（秒）
     * @returns {Promise<HTMLCanvasElement>} - 返回包含帧画面的canvas元素
     */
    async getVideoFrameAtSecond(videoUrl, seconds) {
      return new Promise((resolve, reject) => {
        // 创建视频元素
        const video = document.createElement("video");

        // 配置视频属性
        video.src = videoUrl;
        video.crossOrigin = "anonymous"; // 处理跨域
        video.preload = "metadata";

        // 视频加载元数据完成后
        video.addEventListener("loadedmetadata", () => {
          // 检查请求的时间是否在视频时长范围内
          if (seconds < 0 || seconds > video.duration) {
            reject(
              new Error(`时间超出视频范围，视频时长: ${video.duration}秒`)
            );
            return;
          }

          // 设置视频当前时间
          video.currentTime = seconds;

          // 当视频seek完成后
          video.addEventListener(
            "seeked",
            () => {
              // 创建canvas元素
              const canvas = document.createElement("canvas");

              // 设置canvas尺寸与视频一致
              canvas.width = video.videoWidth;
              canvas.height = video.videoHeight;

              // 在canvas上绘制当前视频帧
              const ctx = canvas.getContext("2d");
              ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

              // 清理资源
              video.remove();

              // 返回canvas
              resolve(canvas);
            },
            { once: true }
          );

          // seek错误处理
          video.addEventListener(
            "error",
            (err) => {
              reject(new Error(`视频定位失败: ${err}`));
              video.remove();
            },
            { once: true }
          );
        });

        // 视频加载错误处理
        video.addEventListener(
          "error",
          (err) => {
            reject(new Error(`视频加载失败: ${err}`));
            video.remove();
          },
          { once: true }
        );
      });
    },
  },
};
</script>

<style></style>
